"use client";

import type { VariantProps } from "class-variance-authority";
import { type PropsWithChildren, useMemo } from "react";

import { cn } from "../../utils";
import { EmptyStateRootContextProvider } from "./context";
import { rootStyles } from "./style";

export type EmptyStateRootProps = PropsWithChildren<
  {
    className?: string;
  } & VariantProps<typeof rootStyles>
>;

const Root = ({ className, children, size }: EmptyStateRootProps) => {
  const contextValue = useMemo(() => ({ size }), [size]);

  return (
    <EmptyStateRootContextProvider value={contextValue}>
      <div className={cn(rootStyles({ size }), className)}>{children}</div>
    </EmptyStateRootContextProvider>
  );
};

export default Root;
